import { render, staticRenderFns } from "./category-details.vue?vue&type=template&id=23fc477c"
import script from "./category-details.vue?vue&type=script&lang=js"
export * from "./category-details.vue?vue&type=script&lang=js"
import style0 from "./category-details.vue?vue&type=style&index=0&id=23fc477c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports